import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useCreditsUsage } from "@/hooks/useCreditsUsage";
import { useNavigate } from "react-router-dom";

interface TokenLimitDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function TokenLimitDialog({ open, onOpenChange }: TokenLimitDialogProps) {
  const { creditUsage, formatCredits } = useCreditsUsage();
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onOpenChange(false);
    navigate("/?plan=upgrade#pricing");
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Limite de Créditos Atingido</AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>
              Você atingiu o limite mensal de créditos do seu plano atual.
            </p>
            {creditUsage && (
              <div className="bg-muted/50 p-3 rounded-lg">
                <p className="text-sm font-medium text-muted-foreground">
                  Uso atual: {formatCredits(creditUsage.total_credits)} / {formatCredits(creditUsage.limit_credits)} créditos
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  Renovação automática no próximo mês
                </p>
              </div>
            )}
            <p>
              Para continuar utilizando o chat com IA, você pode:
            </p>
            <ul className="list-disc list-inside text-sm space-y-1 ml-2">
              <li>Fazer upgrade para um plano superior</li>
              <li>Comprar créditos avulsos</li>
              <li>Aguardar a renovação do ciclo mensal</li>
            </ul>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex flex-col gap-2 mt-4">
          <Button onClick={handleUpgrade} className="w-full">
            Fazer Upgrade do Plano
            <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
          <AlertDialogAction asChild>
            <Button variant="outline" className="w-full">
              Entendi
            </Button>
          </AlertDialogAction>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}